<template>
  <div>
    <p>{{ $t('text.noParentConsent')}}</p>
    <v-btn color="primary ma-1" href="/logout">{{ $t('button.logout')}}</v-btn>
  </div>
</template>

<script>
export default {
  name: "neoparent-no-parent-consent"
}
</script>

<style scoped>

</style>
